module.exports = __webpack_public_path__ + "img/catgory.b16dd24f.png";